import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HeaderPage from '../../components/HeaderPage';
import { toast } from 'react-hot-toast';
import axiosInstance, { Host, weburl } from '../../../axiosInstance';
import getDecryptData from '../../../helper/getDecryptData';
import LoadingScreen from '../../components/LoadingScreen';

const AccountProfile = () => {
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [inputs, setInputs] = useState({
    username: '',
    email: '',
    phone: '',
    Gender: '1',
    state: '',
    statename: '',
    city: '',
    pincode: '',
    address: '',
    profile: null,
    SetEmail: '',
  });
  const [data, setData] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);

  const fetchUserById = async () => {
    const decryptdatajson = await getDecryptData();
    const id = decryptdatajson?._id;

    try {
      const { data } = await axiosInstance.post("/auth-user", { id });
      if (data.success) {
        setInputs({
          username: data.existingUser.username || '',
          email: data.existingUser.email || '',
          phone: data.existingUser.phone || '',
          Gender: data.existingUser.Gender || '1',
          state: data.existingUser.state || '',
          statename: data.existingUser.statename || '',
          city: data.existingUser.city || '',
          pincode: data.existingUser.pincode || '',
          address: data.existingUser.address || '',
          profile: data.existingUser.profile || '',
          SetEmail: data.existingUser.email || '',
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch user');
    } finally {
      setLoading(false);
    }
  };

  const fetchStates = async () => {
    try {
      const res = await axiosInstance.get("/get-all-zones");
      setData(res.data.Zones);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchStates();
    fetchUserById();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    let newValue = type === 'file' ? files[0] : value;

    if (name === 'state') {
      const selectedState = data.find((s) => s._id === value);
      setFilteredCities(selectedState?.cities || []);
      setInputs((prev) => ({ ...prev, state: value, statename: selectedState?.name, city: '' }));
      return;
    }

    setInputs((prev) => ({ ...prev, [name]: newValue }));
  };

  const handleProfileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        document.getElementById('ProfileImage').src = ev.target.result;
      };
      reader.readAsDataURL(file);
      setInputs((prev) => ({ ...prev, profile: file }));
    }
  };

  const handleSubmit = async () => {
    const requiredFields = ['username', 'email', 'phone', 'Gender', 'state', 'city', 'pincode', 'address'];
    for (let field of requiredFields) {
      if (!inputs[field]) {
        toast.error(`Please enter ${field}`);
        return;
      }
    }

    try {
      setSubmitLoading(true);
      const decryptdatajson = await getDecryptData();
      const id = decryptdatajson?._id;
      const res = await axiosInstance.post(`/admin/update-user-details/${id}`, inputs, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) toast.success("Profile Updated Successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to update profile');
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <>
      <Header />
      <HeaderPage title="Account Profile" />
      <main className="page-content bg-light py-5">
        <div className="container">
          {loading ? <LoadingScreen /> :
            <div className="card shadow-sm border-0 p-4">
              <div className="row">
                {/* Profile Picture */}
                <div className="col-md-3 text-center mb-4">
                  <img
                    id="ProfileImage"
                    src={inputs.profile ? `${Host}/uploads/users/${inputs.profile}` : '/assets/img/user.jpg'}
                    alt="Profile"
                    className="img-fluid rounded-circle mb-3 shadow-sm"
                    style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                  />
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control form-control-sm"
                    onChange={handleProfileChange}
                  />
                </div>

                {/* Form Fields */}
                <div className="col-md-9">
                  <div className="row g-3">

                    <div className="col-md-6">
                      <label className="form-label">Full Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="username"
                        value={inputs.username}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={inputs.email}
                        readOnly={inputs.SetEmail !== ''}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Phone</label>
                      <input type="text" className="form-control" name="phone" value={inputs.phone} readOnly />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Gender</label>
                      <select className="form-control" name="Gender" value={inputs.Gender} onChange={handleChange}>
                        <option value="1">Male</option>
                        <option value="2">Female</option>
                        <option value="0">Other</option>
                      </select>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">State</label>
                      <select className="form-control" name="state" value={inputs.state} onChange={handleChange}>
                        <option value="">Select State</option>
                        {data.map((item) => (
                          <option key={item._id} value={item._id}>{item.name}</option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">City</label>
                      <select className="form-control" name="city" value={inputs.city} onChange={handleChange}>
                        <option value="">Select City</option>
                        {filteredCities.map((city, index) => (
                          <option key={index} value={city}>{city}</option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Pincode</label>
                      <input type="text" className="form-control" name="pincode" value={inputs.pincode} onChange={handleChange} />
                    </div>

                    <div className="col-md-12">
                      <label className="form-label">Address</label>
                      <textarea className="form-control" name="address" value={inputs.address} onChange={handleChange} rows={3} />
                    </div>

                    <div className="col-12 text-end mt-3">
                      <button
                        className="btn btn-primary w-100 w-md-auto"
                        onClick={handleSubmit}
                        disabled={submitLoading}
                      >
                        {submitLoading ? <span className="spinner-border spinner-border-sm me-2"></span> : null}
                        Update Profile
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </main>
      <Footer />
    </>
  );
};

export default AccountProfile;
